import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { Solution } from '../_types/solution';

export const getOrganizationSolutions = async (
  orgId: string,
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void
): Promise<Solution[]> => {
  try {
    const url = `${baseApiUrl()}/admin-solution/v1/organizations/${orgId}/solutions`;
    const data: Solution[] = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useOrganizationSolutions(
  orgId: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<Solution[], ServerErrorResponse>(
    ['organizationSolutions', orgId],
    async ({ signal }): Promise<Solution[]> => {
      return getOrganizationSolutions(orgId, signal, onError);
    },
    {
      keepPreviousData: true,
      enabled: !!orgId,
      ...options,
    }
  );
}
